module.exports = __webpack_public_path__ + "media/car_video.6387e2aa.mp4";